export { WindowContext, useWindow, useDocument, WindowProvider } from './WindowProvider';
export type { WindowProviderProps } from './WindowProvider';

import './version';
